import { LOADING, STATUS_CODE } from "../../constants/constant";
import {
  COUNTRY_CODE_AND_NAME_REQUESTED,
  COUNTRY_CODE_AND_NAME_FAILED,
  COUNTRY_CODE_AND_NAME_SUCCESS
} from "../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function countryCodeAndNameReducer(state = initialState, action) {
  switch (action.type) {
    case COUNTRY_CODE_AND_NAME_REQUESTED:
      let requestState = Object.assign({}, state);
      requestState.isLoading = true;
      requestState.status = LOADING;
      requestState.statusCode = STATUS_CODE;
      return requestState;

    case COUNTRY_CODE_AND_NAME_SUCCESS:
      let response = Object.assign({}, state);
      response.status = action.data.data.status_message;
      response.statusCode = action.data.data.status_code;
      response.isLoading = false;
      response.data = action.data.data.data.data.countries;
      return response;

    case COUNTRY_CODE_AND_NAME_FAILED:
      return Object.assign({}, state, action.error);

    default:
      return state;
  }
}
